import { Box, Button, Grid, Paper, styled, Typography } from '@mui/material';

import { BeneficiaryTypes } from './services';

interface BeneficiaryDisplayContentConditionsProps {
  beneficiaries: BeneficiaryTypes[];
}

export const AddYourBeneficiariesPaperStyled = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  boxShadow: '0px 1px 10px 0px #0000003D',
}));

export const AddBeneficiariesBoxStyled = styled(Box)(({ theme }) => ({
  // padding: theme.spacing(7.5),
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    // padding: '0 1.2rem 3rem 1.2rem',
  },
}));

export const AddPrimaryBeneficiariesAllocationDropdownStyled = styled(Box)(
  ({ theme }) => ({
    margin: theme.spacing(5, 0),
    [theme.breakpoints.up('sm')]: {
      float: 'right',
      width: '26rem',
    },
  })
);

export const AddBeneficiariesTotalAllocationGridStyled = styled(
  Grid
)<BeneficiaryDisplayContentConditionsProps>(({ theme, beneficiaries }) => ({
  [theme.breakpoints.down('md')]: {
    // marginLeft: '26rem',
  },
  [theme.breakpoints.down('sm')]: {
    margin: beneficiaries?.length > 0 && '1rem 0 0 auto',
    top: 'auto',
  },
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  borderRadius: '55px',
  padding: '12px 20px',
  border: `1px solid ${theme.palette.primary.main}`,
}));

export const BeneficiaryDependentDataWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '24',
    marginBottom: theme.spacing(2),
  },
}));
